import { createSelector } from "reselect";

import { AltarStore } from "shared/types";

const selectAwsS3Upload = (state: AltarStore) => state.aws.s3.upload;

export const getUploadProgress = () => createSelector(selectAwsS3Upload, state => state.progress);
export const getUploadError = () => createSelector(selectAwsS3Upload, state => state.error);
